import Cache from "./Cache";
import RedisRepository from "./Redis.cache";

let cacheInstance: Cache | null = null;
export function GetCache(): Cache {
  if (!cacheInstance) {
    cacheInstance = new RedisRepository();
  }
  return cacheInstance;
}

export default GetCache;

